import React from 'react';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { getClickToAddDoorHintState } from '../Reducers/App/Selectors';
import { green } from '../Screens/Colors';

const useStyles = makeStyles(
  () => ({
    addDoorHint: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: 310,
      transform: 'translate(-50%, -120%)',
    },
    hintText: {
      fontSize: 24,
      fontWeight: 'bold',
      color: green,
      textAlign: 'center',
    },
    icon: {
      color: green,
      fontSize: 30,
    },
  }),
  {
    name: 'ClickToAddDoor',
  }
);

export const ClickToAddDoorHint = () => {
  const classes = useStyles();
  const { show, top, left } = useSelector(getClickToAddDoorHintState);
  if (!show) return;
  return (
    <div className={classes.addDoorHint} style={{ left, top }}>
      <Typography className={classes.hintText} variant="body1">
        {t('hintMessages.addDoorHint')}
      </Typography>
      <ArrowDownwardIcon className={classes.icon} />
    </div>
  );
};

export default ClickToAddDoorHint;
